import { watchAuth } from '@crm-framework/auth';

import { watchApp } from '@crm-package/app';
import { watchNotifications } from '@crm-package/notifications';

export const coreSagas = [watchApp, watchAuth, watchNotifications];
